import * as D from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function Dialog(props: {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  title: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
  description?: string;
}) {
  return (
    <D.Root open={props.open} onOpenChange={props.onOpenChange}>
      <D.Portal>
        <D.Overlay className="fixed inset-0 z-40 bg-black/35" />
        <D.Content
          className={cn('panel fixed left-1/2 top-1/2 z-50 flex max-h-[90vh] w-[min(720px,95vw)] -translate-x-1/2 -translate-y-1/2 flex-col rounded-lg shadow-2xl', props.className)}
          onOpenAutoFocus={(e) => {
            const el = (e.currentTarget as HTMLElement).querySelector<HTMLElement>('[data-autofocus], input, select, textarea');
            if (el) { e.preventDefault(); el.focus(); }
          }}
        >
          <div className="flex items-center justify-between border-b b-border px-4 py-2.5">
            <D.Title className="text-sm font-semibold">{props.title}</D.Title>
            <D.Close className="rounded p-1 hover:bg-black/5" aria-label="Kapat"><X size={16} /></D.Close>
          </div>
          {props.description && <D.Description className="sr-only">{props.description}</D.Description>}
          <div className="min-h-0 flex-1 overflow-auto p-4 scroll-thin">{props.children}</div>
          {props.footer && <div className="flex justify-end gap-2 border-t b-border px-4 py-2.5">{props.footer}</div>}
        </D.Content>
      </D.Portal>
    </D.Root>
  );
}
